import { assets } from 'assets'
import {
   AdminPanelContainer,
   Button,
   DropDownList,
   FlexContainer,
   SelectBrandPopup,
   SelectProductPopup,
   SubPagesBar,
   TSection
} from 'components'
import { ELocales } from 'enums'
import { useLocalization, useTypedSelector } from 'hooks'
import i18next, { t } from 'i18next'
import { FC, SyntheticEvent, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import {
   getMainProductSelector,
   ApiProductService,
   getUserSelector,
   clientActions,
   getMainClientSelector
} from 'store'
import { TBrand } from 'store/brand/types'
import { TProduct } from 'store/product/types'
import { BrandsTable, DiscountHeader, ProductsTable } from './components'
import { Line } from './styled'
import { CUSTOMER_DISCOUNT, TGetCustomerByIdResponse } from 'store/client/types'
import { PAGE_LIMIT, discountOptions } from './consts'
import _ from 'lodash'
import {
   useGetClient,
   useGetCustomerDiscount,
   useGetCustomerDiscountInfinite
} from 'store/client/api.service'
import { transformResToData } from './utils'

export const DiscountSystem: FC = () => {
   const navigate = useNavigate()
   const dispatch = useDispatch()
   const [locale] = useLocalization()
   const { id } = useParams()
   const [isCheckedBrands, setCheckedBrands] = useState(false)
   const [isChecked, setChecked] = useState<boolean>(false)
   const [productsPopupVisability, setProductsPopupVisability] = useState(false)
   const [brandsPopupVisability, setBrandsPopupVisability] = useState(false)

   const [selectedProducts, setSelectedProducts] = useState<
      (TProduct & { discount?: number })[]
   >([])
   const [selectedBrands, setSelectedBrands] = useState<
      (TBrand & { discount?: number })[]
   >([])
   const { loading: productLoading } = useTypedSelector(getMainProductSelector)

   const { loading, response } = useTypedSelector(getMainClientSelector)
   const { accessToken } = useTypedSelector(getUserSelector)
   const token = 'Bearer ' + accessToken
   const { userData, isLoading: userLoading } = useGetClient({ _id: id || '', token })
   // const client = userData?.data?.data

   const {
      discountData: customerDiscountBrands,
      isEndList: brandsEnd,
      loadMoreClick: brandsLoadMore
   } = useGetCustomerDiscountInfinite(
      {
         _id: id as string,
         lang: locale,
         type: CUSTOMER_DISCOUNT.brand,
         page: 0,
         limit: PAGE_LIMIT,
         token
      },
      (res) => {
         const discountList = transformResToData(res)
         const updatedData = discountList
            // .filter((item) => item?.brand?._id)
            .map((item) => ({ ...item?.brand, discount: item.discount ?? undefined }))
         setSelectedBrands(updatedData)
      }
   )

   const {
      discountData: customerDiscountProducts,
      loadMoreClick,
      isEndList
   } = useGetCustomerDiscountInfinite(
      {
         _id: id as string,
         lang: locale,
         type: CUSTOMER_DISCOUNT.product,
         page: 0,
         limit: PAGE_LIMIT,
         token
      },
      (res) => {
         const discountProductsList = transformResToData(res)
         const newProducts = discountProductsList
            // .filter((item) => item?.product?._id)
            .map((item) => ({
               ...item.product,
               discount: item.discount ?? undefined
            })) as TProduct[]
         setSelectedProducts(newProducts)
      }
   )

   const [form, setForm] = useState({
      discountPriceProducts: '',
      discountPriceBrands: '',
      discountOption: ''
   })

   const filteredProducts = useMemo(() => {
      const uniqueArr = _.uniqWith(selectedProducts, _.isEqual)

      return uniqueArr
   }, [selectedProducts])

   const filteredBrands = useMemo(() => {
      return _.uniq(selectedBrands)
   }, [selectedBrands])
   const existingProductIds =
      customerDiscountProducts?.data.map((i) => i?.product?._id) || []
   const existingBrandsIds = customerDiscountBrands?.data.map((i) => i?.brand?._id) || []

   const Events = {
      backButtonClickHandler: () => {
         navigate(`/businessClients/${id as string}`)
      },
      inputChangeHandler: (e: SyntheticEvent) => {
         const { name, value } = e.target as HTMLInputElement

         if (name === 'discountOption' && value === 'products.discount') {
            setProductsPopupVisability(true)
            return
         }
         if (name === 'discountOption' && value === 'brands.discount') {
            setBrandsPopupVisability(true)
            return
         }

         setForm((props) => ({ ...props, [name]: value }))
      },
      checkedBrandsStateHandler: (e: SyntheticEvent) => {
         setCheckedBrands(!isCheckedBrands)
      },
      checkedStateHandler: () => {
         setChecked(!isChecked)
      },
      setProductsPopupVisiablity: () => {
         setProductsPopupVisability(!productsPopupVisability)
      },
      setBrandsPopupVisiablity: () => {
         setBrandsPopupVisability(!brandsPopupVisability)
      },
      productPopupAddHandler: async (products: string[]) => {
         const res = await Promise.all(products.map((id) => Requests.getProductById(id)))

         setSelectedProducts(
            selectedProducts
               .concat(res as any)
               .flat()
               .filter((value, index, self) => {
                  return self.findIndex((v) => v._id === value._id) === index
               })
         )
         setProductsPopupVisability(false)
      },
      clearProducts: () => {
         dispatch(
            clientActions.deleteCustomerDiscountBulk({
               _id: customerDiscountProducts?.data
                  ?.filter((item) =>
                     filteredProducts?.map((item) => item._id).includes(item.product._id)
                  )
                  .map((item) => item._id)
            })
         )

         setSelectedProducts([])
      },
      clearBrands: () => {
         dispatch(
            clientActions.deleteCustomerDiscountBulk({
               _id: customerDiscountBrands?.data
                  .filter((item) =>
                     filteredBrands?.map((item) => item._id).includes(item?.brand?._id)
                  )
                  .map((item) => item._id)
            })
         )

         setSelectedBrands([])
      },
      clearAll: () => {
         dispatch(
            clientActions.deleteCustomerDiscountBulk({
               _id: customerDiscountBrands?.data
                  .filter((item) =>
                     filteredBrands?.map((item) => item._id).includes(item?.brand?._id)
                  )
                  .map((item) => item._id)
                  .concat(
                     customerDiscountProducts?.data
                        ?.filter((item) =>
                           filteredProducts
                              ?.map((item) => item._id)
                              .includes(item.product._id)
                        )
                        .map((item) => item._id) as string[]
                  )
            })
         )

         setSelectedBrands([])
         setSelectedProducts([])
      },
      saveCustomerDiscount: async () => {
         const isSameProductPrice = isChecked
         const isSameBrandsPrice = isCheckedBrands
         const updatedDataProducts = filteredProducts
            ?.filter((item) =>
               // (item.discount || +form.discountPriceProducts) &&
               existingProductIds.includes(item?._id)
            )
            .map((item) => {
               const discountProduct = customerDiscountProducts?.data.find(
                  (i) => i?.product?._id === item._id
               )

               return {
                  _id: discountProduct?._id,
                  discount: isChecked ? +form.discountPriceProducts : item?.discount || 0,
                  product: item?.guid,
                  customer: id
               }
            })

         const createdDataProducts = filteredProducts
            ?.filter(
               (item) =>
                  // (item.discount || +form.discountPriceProducts) &&
                  !existingProductIds.includes(item?._id)
            )
            .map((item) => ({
               discount: isChecked ? +form.discountPriceProducts : item?.discount || 0,
               product: item?.guid,
               customer: id
            }))

         const updatedDataBrands = filteredBrands
            ?.filter((item) =>
               // (item.discount || +form.discountPriceBrands) &&
               existingBrandsIds.includes(item?._id)
            )
            .map((item) => {
               const discountBrand = customerDiscountBrands?.data.find(
                  (i) => i?.brand?._id === item._id
               )

               return {
                  _id: discountBrand?._id,
                  discount: isCheckedBrands
                     ? +form.discountPriceBrands || 0
                     : item?.discount || 0,
                  brand: item?._id,
                  customer: id
               }
            })

         const createdDataBrands = filteredBrands
            ?.filter(
               (item) =>
                  // (item.discount || +form.discountPriceBrands) &&
                  !existingBrandsIds.includes(item?._id)
            )
            .map((item) => ({
               discount: isCheckedBrands
                  ? +form.discountPriceBrands || 0
                  : item?.discount || 0,
               brand: item?._id,
               customer: id
            }))

         dispatch(
            clientActions.customerDiscountBulk({
               updatedData: [...updatedDataBrands, ...updatedDataProducts],
               createdData: [...createdDataBrands, ...createdDataProducts]
            })
         )
         if (isSameProductPrice) {
            await ApiProductService.setAllDiscountPrice({
               token,
               type: 'product',
               customer: id || '',
               discount: +form.discountPriceProducts || 0
            })
         }
         if (isSameBrandsPrice) {
            await ApiProductService.setAllDiscountPrice({
               token,
               type: 'brand',
               customer: id || '',
               discount: +form.discountPriceBrands || 0
            })
         }
      }
   }

   const Requests = {
      getProductById: async (_id: string): Promise<string> => {
         const response = await ApiProductService.getProduct({
            token: accessToken as string,
            _id,
            lang: i18next.language as ELocales
         })

         return response.data.data
      }
   }

   const sections: TSection[] = useMemo(
      () => [
         {
            title: t('main.data'),
            onClickHandler: () => {
               navigate(`/businessClients/${id}`)
            }
         },
         {
            title: t('orders.history'),
            onClickHandler: () => {
               navigate(`/businessClients/${id}/historyOrders`)
            }
         },
         {
            title: t('discount.system'),
            active: true
         }
      ],
      []
   )

   useEffect(() => {
      if (response == 'DELETED') {
         window.location.reload()
      }
   }, [response])

   return (
      <AdminPanelContainer
         Header={<DiscountHeader Events={Events} />}
         loading={productLoading || loading}>
         <SubPagesBar sections={sections} />
         <FlexContainer padding="0px" direction="column" width="95%">
            {id && filteredProducts?.length > 0 && customerDiscountProducts && (
               <ProductsTable
                  isEndList={isEndList}
                  loadMoreClick={loadMoreClick}
                  form={form}
                  selectedProducts={filteredProducts}
                  setSelectedProducts={setSelectedProducts}
                  Events={Events}
                  isChecked={isChecked}
                  customerDiscount={customerDiscountProducts}
                  customerId={id}
               />
            )}

            {(filteredProducts?.length > 0 || filteredBrands?.length > 0) && <Line />}

            {id && filteredBrands?.length > 0 && (
               <BrandsTable
                  form={form}
                  selectedBrands={filteredBrands}
                  setSelectedBrands={setSelectedBrands}
                  Events={Events}
                  customerDiscount={customerDiscountBrands as TGetCustomerByIdResponse}
                  isCheckedBrands={isCheckedBrands}
                  customerId={id}
                  isEndList={brandsEnd}
                  loadMoreClick={brandsLoadMore}
               />
            )}
         </FlexContainer>

         <DropDownList
            width="189px"
            name="discountOption"
            placeholder={t('create')}
            options={discountOptions}
            onChange={Events.inputChangeHandler}
            createDiscount={true}
            textAlign={'center'}
            whiteArrow={true}
         />

         {productsPopupVisability && (
            <SelectProductPopup
               activeItems={selectedProducts.map((item) => item._id)}
               closeClickHandler={() => Events.setProductsPopupVisiablity()}
               addProductClickHandler={(products) => {
                  Events.productPopupAddHandler(products)
               }}
               checkAll={true}
               discountPopup={true}
            />
         )}

         {brandsPopupVisability && (
            <SelectBrandPopup
               activeItems={selectedBrands.map((item) => item._id)}
               closeClickHandler={() => Events.setBrandsPopupVisiablity()}
               addProductClickHandler={(brands) => {
                  setSelectedBrands(selectedBrands.concat(brands))
                  setBrandsPopupVisability(false)
               }}
            />
         )}
      </AdminPanelContainer>
   )
}
